import React, { Component } from "react";
import { scale, clamp } from "./functional.js";

class PTStaticDialogue extends Component {
  constructor(props) {
    super(props);
    this.baseClassNames = ["inky-output"];
    this.textLengthDomain = [80, 200];
    this.fontSizeRange = [20, 13];
  }
  render() {
    if (this.props.text) {
      return (
        <div
          className={this.getClassNames()}
          style={{
            "font-size": clamp(
              scale(
                this.props.text.length,
                this.textLengthDomain,
                this.fontSizeRange
              ),
              this.fontSizeRange
            ),
          }}
        >
          {this.props.text}
        </div>
      );
    } else {
      return <div />;
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.text && this.props.text !== prevProps.text) {
      setTimeout(this.props.completionHandler, this.props.delay);
    }
  }
  getClassNames() {
    return this.baseClassNames.join(" ");
  }
}

class PTNarratorBox extends PTStaticDialogue {
  constructor(props) {
    super(props);
    this.baseClassNames = ["pt-narrator"];
    this.textLengthDomain = [90, 450];
    this.fontSizeRange = [28, 14];
  }
}
class PTYouDialogue extends PTStaticDialogue {
  constructor(props) {
    super(props);
    this.baseClassNames = ["pt-dialogue-you", "inky-output"];
  }
}

export { PTNarratorBox, PTYouDialogue };



// WEBPACK FOOTER //
// ./src/static_dialogue.js